import Loading from '@components/v2/ui/Loading/Loading';
import { Stack } from '@mui/material';
import { useEffect } from 'react';

const LOADING_BOX_WIDTH = 120;

interface OrderTargetSummaryLoadingProps {
  onOpen: () => void;
}

const OrderTargetSummaryLoading = ({ onOpen }: OrderTargetSummaryLoadingProps) => {
  useEffect(onOpen, []);

  return (
    <Stack sx={{ width: LOADING_BOX_WIDTH, alignItems: 'center', justifyContent: 'center', py: 1 }}>
      <Loading />
    </Stack>
  );
};

export default OrderTargetSummaryLoading;
